export default __webpack_public_path__ + "static/media/27-thinking-face_1f914.caf405cf.png";